import { useCallback, useState } from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import Loader from '@/components/Loader';
import Tabs from '@/components/Tabs';
import {
  METADATA_COMPANY_NAME_FIELD,
  METADATA_FIRST_NAME_FIELD,
  METADATA_LAST_NAME_FIELD
} from '@/constants/constants';
import { PageInformationContext } from '@/context/PageInformationContext';
import useDocumentTitleRename from '@/hooks/useDocumentTitleRename';
import Preferences from '@/pages/Profile/Preferences';
import { retrieveFromUserMetadata } from '@/utils/retrieveFromUserMetadata';
import { RootState } from 'store';

import AccountDetails from './AccountDetails';
import PersonalDetails from './PersonalDetails';

const settingTabs = [
  {
    name: 'preferences',
    label: 'Preferences'
  },
  {
    name: 'personal-details',
    label: 'Personal Details'
  },
  {
    name: 'account-details',
    label: 'Account Details'
  }
];
const pageInformation = {
  mainPageTitle: 'Settings'
};
const Profile = () => {
  const userConfigState = useSelector((state: RootState) => state.userConfig);
  const authState = useSelector((state: RootState) => state.auth);

  const [activeTab, setActiveTab] = useState(0);

  useDocumentTitleRename('GX Go | Settings');
  const renderTabContent = useCallback(() => {
    switch (activeTab) {
      case 1:
        return (
          <PersonalDetails
            companyName={retrieveFromUserMetadata(
              authState.metadata ?? [],
              METADATA_COMPANY_NAME_FIELD
            )}
            email={authState.userEmail}
            firstName={retrieveFromUserMetadata(
              authState.metadata ?? [],
              METADATA_FIRST_NAME_FIELD
            )}
            lastName={retrieveFromUserMetadata(authState.metadata ?? [], METADATA_LAST_NAME_FIELD)}
          />
        );
      case 2:
        return <AccountDetails />;
      default:
        return <Preferences />;
    }
  }, [activeTab, authState.metadata, authState.userEmail]);
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          mt: 3,
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            sx={{ mr: 4 }}
            variant='h2'
          >
            Settings
          </Typography>
          <PageInformationContext.Provider value={pageInformation}>
            <Tabs
              activeTab={activeTab}
              minTabWidth={120}
              tabs={settingTabs}
              onChange={index => {
                setActiveTab(index);
              }}
            />
          </PageInformationContext.Provider>
        </Box>
      </Box>

      {userConfigState.status === 'loading' ? (
        <Loader />
      ) : (
        <Stack
          useFlexGap
          direction='row'
          flexWrap='wrap'
          spacing={{ xs: 2, sm: 3 }}
          sx={{ width: '100%', mt: 3 }}
        >
          {renderTabContent()}
        </Stack>
      )}
    </>
  );
};

export default Profile;
